export default {"src":"/_next/static/media/paginarition-arrow-right.dcd2ac56.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};